import { dbAdd, dbDelete, dbGetAll, dbGetById, dbPut } from '../indexedDb.ts';

export interface LocalInvestmentScenario {
  id: number;
  plan_id: number;
  name: string;
  return_adjustment: number;
  inflation_adjustment: number;
  retirement_age_adjustment?: number;
  notes?: string;
  created_at: string;
  updated_at?: string;
  server_id?: number;
  last_synced_at?: string;
  needs_sync?: boolean;
}

export function listInvestmentScenarios() {
  return dbGetAll<LocalInvestmentScenario>('investment_scenarios');
}

export async function listScenariosByPlan(planId: number) {
  const all = await listInvestmentScenarios();
  return all.filter((scenario) => scenario.plan_id === planId);
}

export function getInvestmentScenarioById(id: number) {
  return dbGetById<LocalInvestmentScenario>('investment_scenarios', id);
}

export async function getInvestmentScenarioByServerId(serverId: number) {
  const all = await listInvestmentScenarios();
  return all.find((scenario) => scenario.server_id === serverId);
}

export async function createInvestmentScenario(
  data: Omit<LocalInvestmentScenario, 'id' | 'created_at' | 'updated_at' | 'server_id' | 'last_synced_at' | 'needs_sync'>
) {
  const now = new Date().toISOString();
  return dbAdd('investment_scenarios', { ...data, created_at: now, needs_sync: true } as any);
}

export async function updateInvestmentScenario(id: number, data: Partial<LocalInvestmentScenario>) {
  const current = await dbGetById<LocalInvestmentScenario>('investment_scenarios', id);
  if (!current) throw new Error('Scenario not found');
  const updated = {
    ...current,
    ...data,
    id,
    updated_at: data.updated_at ?? new Date().toISOString(),
    needs_sync: data.needs_sync ?? true,
  };
  await dbPut('investment_scenarios', updated);
  return updated;
}

export function removeInvestmentScenario(id: number) {
  return dbDelete('investment_scenarios', id);
}

export async function markInvestmentScenarioSynced(id: number, serverId: number) {
  const current = await dbGetById<LocalInvestmentScenario>('investment_scenarios', id);
  if (!current) throw new Error('Scenario not found');
  current.server_id = serverId;
  current.last_synced_at = new Date().toISOString();
  current.needs_sync = false;
  await dbPut('investment_scenarios', current);
  return current;
}
